module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/report-items/flagged-questions-list-simple/flagged-questions-list-simple.component.scss
// module id = ./src/app/reports/report-items/flagged-questions-list-simple/flagged-questions-list-simple.component.scss
// module chunks = main